// Метод для форматирования размера
const formatSize = (size) => {
  // Проверка: если размер можно представить как целое число, убираем дробную часть
  return Number.isInteger(Number(size)) ? Number(size) : Number(size).toFixed(1);
};

// Служебные цвета, которые в артикул не дописываются:
// 0 — «светлая бронза» (базовый цвет), 99 — «без цветов»
const BASE_COLOR_ID = 0;
const NO_COLOR_ID = 99;

// К артикулу выбранного цвета дописывается его код: 252 + «белый матовый» (3)
// даёт 252-3. Правило одно на весь сайт — карточка товара и корзина
const formatVendorCode = (vendorCode, colorId) => {
  if (vendorCode === null || vendorCode === undefined || vendorCode === "") return "";

  const id = Number(colorId);
  const withCode =
    Number.isInteger(id) && id > BASE_COLOR_ID && id < NO_COLOR_ID;

  return withCode ? `${vendorCode}-${id}` : `${vendorCode}`;
};

// Цвет показывается покупателю, только если он настоящий:
// «без цветов» — служебная отметка для товаров без вариаций
const isRealColor = (colorId) =>
  colorId !== null && colorId !== undefined && Number(colorId) !== NO_COLOR_ID;

// Белые и почти белые цвета (#ffffff, «слоновая кость») на белом фоне
// не видны — таким образцам нужна рамка
const isLightColor = (hex) => {
  const match = /^#?([0-9a-f]{6})$/i.exec(hex ?? "");
  if (!match) return false;
  const n = parseInt(match[1], 16);
  return 0.299 * (n >> 16) + 0.587 * ((n >> 8) & 255) + 0.114 * (n & 255) > 225;
};

export { formatSize, formatVendorCode, isRealColor, isLightColor, NO_COLOR_ID };
